/* Both cards stay server-rendered; controls progressively choose the pair. */
(() => {
  function init(root) {
    if (root.dataset.pairReady) return;
    const cards = [...root.querySelectorAll('[data-pair-card]')];
    const selectors = [...root.querySelectorAll('[data-pair-select]')];
    if (cards.length < 2 || selectors.length !== 2) return;
    const controls = root.querySelector('[data-pair-controls]');
    const status = root.querySelector('[data-pair-status]');
    const available = cards.filter(card => card.dataset.pairAvailable === 'true');
    let pair = (available.length >= 2 ? available : cards).slice(0, 2).map(card => card.dataset.pairCard);
    function paint(announce) {
      selectors.forEach((select, side) => { select.value = pair[side]; });
      cards.forEach(card => {
        const side = pair.indexOf(card.dataset.pairCard);
        card.hidden = side < 0;

      });
      const container = root.querySelector('.j-cut-pair__cards');
      pair.forEach(id => container.append(cards.find(card => card.dataset.pairCard === id)));
      if (announce) {
        const titles = pair.map(id => cards.find(card => card.dataset.pairCard === id).dataset.pairTitle);
        status.textContent = `${titles[0]} und ${titles[1]} im Vergleich.`;
      }
    }
    selectors.forEach((select, side) => {
      select.addEventListener('change', () => {
        const next = select.value;
        if (!cards.some(card => card.dataset.pairCard === next)) return;
        const previous = pair[side];
        if (pair[1 - side] === next) pair[1 - side] = previous;
        pair[side] = next;
        paint(true);
      });
    });
    paint(false);
    root.dataset.pairReady = 'true';
    controls.hidden = false;
  }
  function scan(scope) { scope.querySelectorAll('[data-cut-pair]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
